import React from "react";
import styled from "styled-components";

const TermsPage = () => {
  return (
    <TermsContainer>
      <h1>Terms and Conditions</h1>

      <p>
        These terms and conditions ("Agreement") set forth the general terms and
        conditions of your use of the slayerscape.com website ("Website" or
        "Service") and any of its related products and services (collectively,
        "Services"). This Agreement is legally binding between you ("User",
        "you" or "your") and this Website operator ("Operator", "we", "us" or
        "our"). By accessing and using the Website and Services, you acknowledge
        that you have read, understood, and agree to be bound by the terms of
        this Agreement. If you are entering into this Agreement on behalf of a
        business or other legal entity, you represent that you have the
        authority to bind such entity to this Agreement, in which case the terms
        "User", "you" or "your" shall refer to such entity. If you do not have
        such authority, or if you do not agree with the terms of this Agreement,
        you must not accept this Agreement and may not access and use the
        Website and Services. You acknowledge that this Agreement is a contract
        between you and the Operator, even though it is electronic and is not
        physically signed by you, and it governs your use of the Website and
        Services.
      </p>

      <h2>Accuracy of Information</h2>
      <p>
        Occasionally there may be information on the Website that contains
        typographical errors, inaccuracies or omissions that may relate to
        pricing, promotions and offers. We reserve the right to correct any
        errors, inaccuracies or omissions, and to change or update information
        or cancel orders if any information on the Website or Services is
        inaccurate at any time without prior notice (including after you have
        submitted your order). We undertake no obligation to update, amend or
        clarify information on the Website including, without limitation,
        pricing information, except as required by law. No specified update or
        refresh date applied on the Website should be taken to indicate that all
        information on the Website or Services has been modified or updated.
      </p>

      <h2>Links to Other Resources</h2>
      <p>
        Although the Website and Services may link to other resources (such as
        websites, mobile applications, etc.), we are not, directly or
        indirectly, implying any approval, association, sponsorship,
        endorsement, or affiliation with any linked resource, unless
        specifically stated herein. Some of the links on the Website may be
        "affiliate links". This means if you click on the link and purchase an
        item, the Operator will receive an affiliate commission. We are not
        responsible for examining or evaluating, and we do not warrant the
        offerings of, any businesses or individuals or the content of their
        resources. We do not assume any responsibility or liability for the
        actions, products, services, and content of any other third parties. You
        should carefully review the legal statements and other conditions of use
        of any resource which you access through a link on the Website and
        Services. Your linking to any other off-site resources is at your own
        risk.
      </p>

      <h2>Intellectual Property Rights</h2>
      <p>
        "Intellectual Property Rights" means all present and future rights
        conferred by statute, common law or equity in or in relation to any
        copyright and related rights, trademarks, designs, patents, inventions,
        goodwill and the right to sue for passing off, rights to inventions,
        rights to use, and all other intellectual property rights, in each case
        whether registered or unregistered and including all applications and
        rights to apply for and be granted, rights to claim priority from, such
        rights and all similar or equivalent rights or forms of protection and
        any other results of intellectual activity which subsist or will subsist
        now or in the future in any part of the world. This Agreement does not
        transfer to you any intellectual property owned by the Operator or third
        parties, and all rights, titles, and interests in and to such property
        will remain (as between the parties) solely with the Operator. All
        trademarks, service marks, graphics and logos used in connection with
        the Website and Services, are trademarks or registered trademarks of the
        Operator or its licensors. Other trademarks, service marks, graphics and
        logos used in connection with the Website and Services may be the
        trademarks of other third parties. Your use of the Website and Services
        grants you no right or license to reproduce or otherwise use any of the
        Operator or third party trademarks.
      </p>

      <h2>Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by applicable law, in no event will the
        Operator, its affiliates, directors, officers, employees, agents,
        suppliers or licensors be liable to any person for any indirect,
        incidental, special, punitive, cover or consequential damages
        (including, without limitation, damages for lost profits, revenue,
        sales, goodwill, use of content, impact on business, business
        interruption, loss of anticipated savings, loss of business opportunity)
        however caused, under any theory of liability, including, without
        limitation, contract, tort, warranty, breach of statutory duty,
        negligence or otherwise, even if the liable party has been advised as to
        the possibility of such damages or could have foreseen such damages. To
        the maximum extent permitted by applicable law, the aggregate liability
        of the Operator and its affiliates, officers, employees, agents,
        suppliers and licensors relating to the services will be limited to an
        amount greater of one dollar or any amounts actually paid in cash by you
        to the Operator for the prior one month period prior to the first event
        or occurrence giving rise to such liability. The limitations and
        exclusions also apply if this remedy does not fully compensate you for
        any losses or fails of its essential purpose.
      </p>

      <h2>Severability</h2>
      <p>
        All rights and restrictions contained in this Agreement may be exercised
        and shall be applicable and binding only to the extent that they do not
        violate any applicable laws and are intended to be limited to the extent
        necessary so that they will not render this Agreement illegal, invalid
        or unenforceable. If any provision or portion of any provision of this
        Agreement shall be held to be illegal, invalid or unenforceable by a
        court of competent jurisdiction, it is the intention of the parties that
        the remaining provisions or portions thereof shall constitute their
        agreement with respect to the subject matter hereof, and all such
        remaining provisions or portions thereof shall remain in full force and
        effect.
      </p>

      <h2>Changes and Amendments</h2>
      <p>
        We reserve the right to modify this Agreement or its terms relating to
        the Website and Services at any time, effective upon posting of an
        updated version of this Agreement on the Website. When we do, we will
        revise the updated date at the bottom of this page. Continued use of the
        Website and Services after any such changes shall constitute your
        consent to such changes.
      </p>

      <h2>Acceptance of These Terms</h2>
      <p>
        You acknowledge that you have read this Agreement and agree to all its
        terms and conditions. By accessing and using the Website and Services
        you agree to be bound by this Agreement. If you do not agree to abide by
        the terms of this Agreement, you are not authorized to access or use the
        Website and Services.
      </p>

      <h2>Contacting Us</h2>
      <p>If you have any questions about these terms, please contact us:</p>
      <ul>
        <li>Email: cpdewolf@gmail.com</li>
        <li>Website: slayerscape.com</li>
      </ul>

      <p>This document was last updated on Nov 1, 2024.</p>
    </TermsContainer>
  );
};

export default TermsPage;

const TermsContainer = styled.div`
  color: rgba(255, 255, 255, 0.85);
  padding: 20px;
  max-width: 800px;
  margin: auto;
  line-height: 1.6;
`;
